import { render, staticRenderFns } from "./de-faq.vue?vue&type=template&id=5b2f3c9c&"
import script from "./de-faq.vue?vue&type=script&lang=js&"
export * from "./de-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports